import React, { useState } from "react";
import "../../assets/css/Daywisetable.css";

const DayWiseTable = ({ dayWiseData, partners, totalUsers }) => {
  const [expandedDay, setExpandedDay] = useState(null);

  const toggleExpand = (idx) => {
    setExpandedDay(expandedDay === idx ? null : idx);
  };

  const OFFER_ROWS = [
  { color: "#378ADD", label: "Clicks", key: (c) => c.total_clicks,     valColor: "#185FA5" },
  { color: "#1D9E75", label: "Done",   key: (c) => c.completed_clicks, valColor: "#0F6E56" },
  { color: "#D85A30", label: "Payout", key: (c) => `$${(c.total_payout / 1000).toFixed(1)}` },
];

const LEGEND_ITEMS = [
  { color: "#378ADD", label: "Clicks — all statuses" },
  { color: "#1D9E75", label: "Done — credited" },
  { color: "#D85A30", label: "Payout — coins ÷ 1000" },
];



  const getActivationClass = (rate) => {
    const r = parseFloat(rate);
    if (r > 10) return "dwt-badge dwt-badge-green";
    if (r > 5)  return "dwt-badge dwt-badge-yellow";
    return "dwt-badge dwt-badge-red";
  };

  return (
    <div>
      <div className="dwt-wrapper">
        <h3 className="dwt-title">📋 Day-wise Performance (D0-D15)</h3>
        <p className="dwt-subtitle">Detailed breakdown of user activity, earnings, and withdrawals</p>
      </div>

      <div className="dwt-scroll">
        <table className="dwt-table">
          <thead className="dwt-thead">
            <tr>
              <th className="dwt-th">Day</th>
              <th className="dwt-th">Earners</th>
              <th className="dwt-th">Activation %</th>
              <th className="dwt-th">Revenue</th>
              <th className="dwt-th">Payout</th>
              <th className="dwt-th">Withdrawals</th>
              <th className="dwt-th">Details</th>
            </tr>
          </thead>
          <tbody>
            {dayWiseData.map((day, idx) => (
              <React.Fragment key={idx}>
                <tr className={idx % 2 === 0 ? "dwt-row-even" : "dwt-row-odd"}>
                  <td className="dwt-td">
                    <span className="dwt-day-label">{day.day}</span>
                  </td>
                  <td className="dwt-td">
                    <span className="dwt-earners">
                      {day.partner_earnings.total_earners.toLocaleString()}
                    </span>
                  </td>
                  <td className="dwt-td">
                    <span className={getActivationClass(day.partner_earnings.activation_rate)}>
                      {day.partner_earnings.activation_rate}%
                    </span>
                  </td>
                  <td className="dwt-td">
                    <span className="dwt-revenue">
                      ${(day.partner_earnings.total_revenue / 1000).toFixed(2)}
                    </span>
                  </td>
                  <td className="dwt-td">
                    <span className="dwt-payout">
                      ${(day.partner_earnings.total_payout / 1000).toFixed(2)}
                    </span>
                  </td>
                  <td className="dwt-td">
                    <span className="dwt-with-users">{day.withdrawals.users} users</span>
                    <br />
                    <span className="dwt-with-coins">
                      ${(day.withdrawals.coins / 1000).toFixed(1)}
                    </span>
                  </td>
                  <td className="dwt-td">
                    <button
                      onClick={() => toggleExpand(idx)}
                      className={`dwt-toggle-btn ${expandedDay === idx ? "active" : "inactive"}`}
                    >
                      {expandedDay === idx ? "Hide ▲" : "Show ▼"}
                    </button>
                  </td>
                </tr>

                {expandedDay === idx && (
                  <tr>
                    <td colSpan="7" className="dwt-expanded-td">

                      {/* Partner Breakdown */}
                      {day.partner_earnings.by_partner.length > 0 && (
                        <div className="dwt-section">
                          <h4 className="dwt-section-title">
                            Top Partners ({day.partner_earnings.by_partner.length})
                          </h4>
                          <div className="dwt-grid-partners">
                            {day.partner_earnings.by_partner
                              .sort((a, b) => b.earners - a.earners)
                              .slice(0, 12)
                              .map((p, i) => (
                                <div key={i} className="dwt-partner-card">
                                  {partners[p.partner_id]?.image && (
                                    <img
                                      src={partners[p.partner_id].image}
                                      alt=""
                                      className="dwt-partner-img"
                                    />
                                  )}
                                  <div style={{ flex: 1, minWidth: 0 }}>
                                    <p className="dwt-partner-name">
                                      {partners[p.partner_id]?.name || "Unknown Partner"}
                                    </p>
                                    <p className="dwt-partner-meta">
                                      {p.earners} users • {p.revenue.toFixed(1)} Coins rev
                                    </p>
                                  </div>
                                </div>
                              ))}
                          </div>
                        </div>
                      )}

                      {/* Survey */}
                      {(() => {
                        const survey = day?.survey;
                        if (!survey) return null;

                        const rateColor = (rate) => {
                          const r = parseFloat(rate);
                          if (r > 70) return { bg: "#D1FAE5", text: "#065F46" };
                          if (r >= 40) return { bg: "#FEF3C7", text: "#92400E" };
                          return { bg: "#FEE2E2", text: "#991B1B" };
                        };

                        // Reusable funnel mini-table inside a card
                        const FunnelCard = ({ header, headerColor, d }) => {
                          if (!d || (d.attempted ?? 0) === 0) return null;
                          const { bg, text } = rateColor(d.completion_rate);
                          const attempted = d.attempted ?? 0;
                          const completed = d.completed ?? 0;
                          const completionPct = attempted > 0 ? (completed / attempted) * 100 : 0;
                          return (
                            <div style={{
                              background: "#fff",
                              border: "1px solid #E5E7EB",
                              borderRadius: 10,
                              padding: "12px 14px",
                              display: "flex",
                              flexDirection: "column",
                              gap: 10,
                              boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                            }}>
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
                                <p style={{
                                  margin: 0,
                                  fontSize: 12,
                                  fontWeight: 700,
                                  color: headerColor ?? "#374151",
                                  letterSpacing: "0.02em",
                                }}>
                                  {header}
                                </p>
                                <span style={{
                                  padding: "2px 8px",
                                  borderRadius: 10,
                                  background: bg,
                                  color: text,
                                  fontSize: 11,
                                  fontWeight: 700,
                                  whiteSpace: "nowrap",
                                }}>
                                  {d.completion_rate}% done
                                </span>
                              </div>

                              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                {[
                                  { label: "Attempted", count: attempted, accent: "#3B82F6", width: 100 },
                                  { label: "Completed", count: completed, accent: "#16A34A", width: completionPct },
                                ].map((row) => (
                                  <div key={row.label}>
                                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 2, fontSize: 11 }}>
                                      <span style={{ color: "#6B7280" }}>{row.label}</span>
                                      <span style={{ fontWeight: 600, color: "#1F2937" }}>
                                        {row.count?.toLocaleString() ?? "—"}
                                      </span>
                                    </div>
                                    <div style={{ height: 4, borderRadius: 2, background: "#F3F4F6", overflow: "hidden" }}>
                                      <div style={{
                                        height: "100%",
                                        width: `${Math.min(row.width, 100)}%`,
                                        background: row.accent,
                                        borderRadius: 2,
                                        transition: "width 0.3s ease",
                                      }} />
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          );
                        };

                        // Collect other_profiler sub-cards
                        const otherEntries = survey.other_profiler && typeof survey.other_profiler === "object"
                          ? Object.entries(survey.other_profiler).filter(([, v]) => (v?.attempted ?? 0) > 0)
                          : [];

                        const hasRegProfiler   = (survey.registration_profiler?.attempted ?? 0) > 0;
                        const hasPartnerSurvey = (survey.partner_survey?.attempted ?? 0) > 0;
                        const hasOther         = otherEntries.length > 0;

                        if (!hasRegProfiler && !hasPartnerSurvey && !hasOther) return null;

                        return (
                          <div className="dwt-section">
                            <h4 className="dwt-section-title">📊 User Survey</h4>

                            <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "flex-start" }}>
                              {/* Registration Profiler */}
                              {hasRegProfiler && (
                                <div style={{ flex: "1 1 240px", minWidth: 220 }}>
                                  <p style={{ margin: "0 0 6px 0", fontSize: 11, fontWeight: 700, color: "#6366F1", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                    Registration Profiler
                                  </p>
                                  <FunnelCard
                                    header="Registration Profiler"
                                    headerColor="#6366F1"
                                    d={survey.registration_profiler}
                                  />
                                </div>
                              )}

                              {/* Partner Survey */}
                              {hasPartnerSurvey && (
                                <div style={{ flex: "1 1 240px", minWidth: 220 }}>
                                  <p style={{ margin: "0 0 6px 0", fontSize: 11, fontWeight: 700, color: "#0891B2", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                    Partner Survey
                                  </p>
                                  <FunnelCard
                                    header="Partner Survey"
                                    headerColor="#0891B2"
                                    d={survey.partner_survey}
                                  />
                                </div>
                              )}

                              {/* Other Profiler — one sub-card per partnerSurveyId */}
                              {hasOther && otherEntries.map(([surveyId, d]) => (
                                <div key={surveyId} style={{ flex: "1 1 240px", minWidth: 220 }}>
                                  <p style={{ margin: "0 0 6px 0", fontSize: 11, fontWeight: 700, color: "#D97706", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                    Other Profiler
                                  </p>
                                  <FunnelCard
                                    header={surveyId}
                                    headerColor="#92400E"
                                    d={d}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        );
                      })()}

                      {/* Offers by Category */}
                {day?.offers?.categories?.length > 0 && (
  <div className="dwt-section">
    <h4 className="dwt-section-title">📦 Offers by Category</h4>

    <div className="dwt-offer-legend">
      {LEGEND_ITEMS.map((item, i) => (
        <span key={i} className="dwt-legend-item">
          <span className="dwt-legend-dot" style={{ background: item.color }} />
          {item.label}
        </span>
      ))}
    </div>

    <div className="dwt-grid-offers">
      {day.offers.categories.map((cat, i) => (
        <div key={i} className="dwt-offer-card">
          <p className="dwt-offer-cat-label">{cat.category}</p>
          {OFFER_ROWS.map((row, j) => (
            <div key={j} className="dwt-offer-row">
              <span className="dwt-offer-row-label">
                <span className="dwt-legend-dot" style={{ background: row.color }} />
                {row.label}
              </span>
              <span className="dwt-offer-row-val" style={{ color: row.valColor || "#1F2937" }}>
                {row.key(cat)}
              </span>
            </div>
          ))}
        </div>
      ))}
    </div>
  </div>
)}

                      {/* Top Offers */}
                      {day?.offers?.top_offers?.length > 0 && (
                        <div className="dwt-section">
                          <h4 className="dwt-section-title">🏆 Top Offers</h4>
                          <div className="dwt-scroll">
                            <table className="dwt-table">
                              <thead className="dwt-thead">
                                <tr>
                                  <th className="dwt-th">#</th>
                                  <th className="dwt-th">Offer</th>
                                  <th className="dwt-th">Users</th>
                                  <th className="dwt-th">Clicks</th>
                                  <th className="dwt-th">Completed</th>
                                  <th className="dwt-th">Completion %</th>
                                  <th className="dwt-th">Payout</th>
                                </tr>
                              </thead>
                              <tbody>
                                {day.offers.top_offers.map((offer, i) => {
                                  const clicks = offer.total_clicks || 0;
                                  const completed = offer.completed_clicks || 0;
                                  const completionRate = clicks > 0 ? ((completed / clicks) * 100).toFixed(1) : "0.0";
                                  return (
                                    <tr key={offer._id ?? offer.offerId ?? i} className={i % 2 === 0 ? "dwt-row-even" : "dwt-row-odd"}>
                                      <td className="dwt-td">
                                        <span className="dwt-top-offer-rank">{i + 1}</span>
                                      </td>
                                      <td className="dwt-td">
                                        <span className="dwt-day-label">{offer.offer_name || "—"}</span>
                                      </td>
                                      <td className="dwt-td">{(offer.total_users || 0).toLocaleString()}</td>
                                      <td className="dwt-td">{clicks.toLocaleString()}</td>
                                      <td className="dwt-td">{completed.toLocaleString()}</td>
                                      <td className="dwt-td">
                                        <span className={getActivationClass(completionRate)}>{completionRate}%</span>
                                      </td>
                                      <td className="dwt-td">
                                        <span className="dwt-payout">${((offer.total_payout || 0) / 1000).toFixed(2)}</span>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}

                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DayWiseTable;